import React from 'react';
import { Grid, Skeleton, Box } from '@mui/material';
import { colors } from '../../../utils';

const FolderSkeleton = ({ count = 16 }) => {
  return (
    <Grid container spacing={2} sx={{ py: 2 }}>
      {[...Array(count)].map((_, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Box
            sx={{
              p: "10px 8px",
              borderRadius: 1,
              border: `1px solid ${colors.lightBorder}`,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: "48px"
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              <Skeleton variant="circular" width={24} height={24} animation="wave" />
              <Skeleton 
                variant="text" 
                sx={{ ml: 1.5, flex: 1 }} 
                width="70%" 
                animation="wave"
              />
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default FolderSkeleton;